import {Box} from "@mui/material";
import * as React from "react";
import AppCopy from "../Common/AppCopyView";

export default function XpRules() {
    return (
        <AppCopy appKey="rules.xp" field="description" component="Box" />
    );
}